export default function Required() {
    return (<span style={{ color: 'red' }}>*</span>);
}